import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { If } from '../if'
import { useIntersection } from '../../../hooks/useIntersectionObserver'

const LazyComponent = (props) => {
  const { children, fallback } = props

  const ref = useRef(null)
  const [isInView, setIsInView] = useState(false)

  useIntersection(ref, () => {
    setIsInView(true)
  })

  return (
    <div ref={ref} style={{ minHeight: 1 }}>
      <If
        condition={isInView}
        render={() => children}
        renderElse={() => fallback}
      />
    </div>
  )
}

LazyComponent.defaultProps = {
  children: <></>,
  fallback: <></>,
}

LazyComponent.propTypes = {
  children: PropTypes.any,
  fallback: PropTypes.any,
}

export { LazyComponent }
